var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.userHasInteracted)?_c('div',{staticClass:"smvp-user-interactor-widget",attrs:{"aria-label":_vm.labels.ariaLabel},on:{"click":_vm.click}},[_c('icon',{attrs:{"name":"play"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }